import { Component, OnInit } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'confirm-dialog',
    templateUrl: './confirm-dialog.component.html',
    styleUrls: ['./confirm-dialog.component.scss']
})
export class ConfirmDialogComponent {

    public confirmHead: string;
    public confirmMessage: string;
    public confirmOkText: string;
    public confirmCancelText: string;
    public emails: any;

    constructor(public dialogRef: MatDialogRef<ConfirmDialogComponent>) {
    }

    ngOnInit() {
    }

}



// WEBPACK FOOTER //
// /vercel/path0/src/app/main/content/apps/e-commerce/solutionForm/confirm-dialog/confirm-dialog.component.ts